/**
 * The parrot mark (design `assets/parrot-mark.svg`, traced from the Figma
 * "Parrot Mark" component, node 103:2). Its five colours are literal in both
 * themes and never a token (design-system.md) — a themed pupil would turn
 * light in dark mode and the eye would read as a hollow white hole.
 */
export default function ParrotMark({ size = 24, className }) {
  return (
    // The drawing spans x 14–150, y 24–185, so its centre is (82, 104), not
    // (100, 100): the viewBox is moved onto it, otherwise the bird sits left
    // of centre in every round avatar it is drawn into.
    <svg width={size} height={size} viewBox="-18 4 200 200" aria-hidden="true" className={className}>
      <path d="M112 50 A38 38 0 0 1 150 88 L112 88 Z" fill="#F5C518" />
      <path d="M112 88 L146 88 A26 26 0 0 1 114 104 Z" fill="#E0AE13" />
      <g stroke="#E0AE13" strokeWidth="7" strokeLinecap="round" fill="none">
        <path d="M76 150 L76 174" />
        <path d="M100 150 L100 174" />
        <path d="M60 181 C66 170 86 170 92 181" />
        <path d="M84 181 C90 170 110 170 116 181" />
      </g>
      <path d="M66 116 C64 146 48 168 22 180 C16 171 14 165 16 159 C40 147 52 133 58 110 Z" fill="#2A5C99" />
      <rect x="52" y="24" width="62" height="128" rx="31" fill="#2A5C99" />
      <ellipse cx="84" cy="124" rx="41" ry="40" fill="#2A5C99" />
      <path d="M40 142 C43 112 70 90 98 97 C122 103 122 130 102 145 C82 160 55 158 40 142 Z" fill="#E0AE13" />
      <path d="M45 138 C50 113 72 95 96 102 C116 108 116 127 99 141 C80 155 59 152 45 138 Z" fill="#F5C518" />
      <path d="M64 146 C84 141 96 129 100 109 C108 129 98 149 76 154 Z" fill="#E0AE13" opacity="0.4" />
      <circle cx="94" cy="64" r="21" fill="#FFFFFF" />
      <circle cx="94" cy="64" r="15" fill="#1B3A66" />
      <circle cx="100" cy="57" r="4.5" fill="#FFFFFF" />
    </svg>
  )
}
